/* eslint-disable import/prefer-default-export */
import type { FilterOption } from '../../../shared/types';

export const findNSelectedOptions = (options: FilterOption[], n = 2) => {
    const selectedItems: FilterOption[] = [];

    for (let index = 0; index < options.length; index++) {
        if (selectedItems.length === n) break;

        const option = options[index];

        if (option.isSelected) {
            selectedItems.push(option);
        }
    }

    return selectedItems;
};
